import { Injectable } from '@angular/core';
import { HttpClient, } from '@angular/common/http';

import { Observable } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';

import {ErrorService, EventService} from '..';
import { Transaction, FileChecksum, UpdateFileChecksum, AddFileChecksumExclusionRequest, ActivityBuildResponse,
  ImportTransactionRequest, ImportTransactionResponse } from '../models';
import {ConfigService} from './config.service';


@Injectable({ providedIn: 'root' })
export class ProjectTransactionService {
    private projectTransactionURL = ConfigService.getApiEndpoint() + 'v1/transaction/';

    constructor(
        private http: HttpClient,
        private eventService: EventService,
        private error: ErrorService
    ) { }

    getOne(id: string): Observable<Transaction> {
        return this.http.get<Transaction>(this.projectTransactionURL + id).pipe(
            catchError(this.error.handleError('projectTransaction.getOne', null))
        );
    }

    saveFileChecksum(id: string, updateProtectionSettingsRequest: UpdateFileChecksum): Observable<FileChecksum[]> {
        return this.http.put<FileChecksum[]>(this.projectTransactionURL + id + '/checksum', updateProtectionSettingsRequest).pipe(
            tap(_ => this.eventService.success('updated protection settings')),
            catchError(this.error.handleError('projectTransaction.saveFileChecksum', null))
        );
    }

    addFileChecksumExclusion(id: string, addFileChecksumExclusionRequest: AddFileChecksumExclusionRequest): Observable<FileChecksum> {
        return this.http.post<FileChecksum>(this.projectTransactionURL + id + '/checksum', addFileChecksumExclusionRequest).pipe(
            tap(_ => this.eventService.success('add file checksum exclusion')),
            catchError(this.error.handleError('projectTransaction.addFileChecksumExclusion', null))
        );
    }

    removeChecksumExclusion(id: string): Observable<FileChecksum[]> {
        return this.http.delete(this.projectTransactionURL + id + '/checksum').pipe(
            tap(_ => this.eventService.success('removeChecksumExclusion')),
            catchError(this.error.handleError('projectTransaction.removeChecksumExclusion', null))
        );
    }

    getProjectTransaction(id: string, query: any): Observable<ActivityBuildResponse> {
        return this.http.get<ActivityBuildResponse>(this.projectTransactionURL + id + '/project', { params: query }).pipe(
            catchError(this.error.handleError('projectTransaction.getProjectTransaction', null))
        );
    }

    getBranchTransaction(id: string, query: any): Observable<ActivityBuildResponse> {
        return this.http.get<ActivityBuildResponse>(this.projectTransactionURL + id + '/branch', { params: query }).pipe(
            catchError(this.error.handleError('projectTransaction.getBranchTransaction', null))
        );
    }


    importTransaction(request: ImportTransactionRequest): Observable<ImportTransactionResponse>{
        return this.http.post<ImportTransactionResponse>(this.projectTransactionURL + 'import/', request).pipe(
            catchError(this.error.handleError('projectTransaction.importTransaction', null))
        );
    }
}
